'use strict'

import $ from 'jquery'

export default class Tabs {
    constructor(el) {
        console.log("loading tabs")
        this.$el = $(el)

        this.$tabsToggle = $(this.$el).find('.tabs__accordion ul div')
        this.tabs = this.$tabsToggle.toArray()
        this.tabsMedia = $(this.$el).find('.tabs__content .tabs__content__item').toArray()
        this.activeContent = 'active-content'
        this.activeTab = 'active-tab'

        console.log("tabs: ", this.$tabsToggle)
        $(() => {
            $(this.tabs[0]).addClass(this.activeTab).attr('aria-expanded', true)
            $(this.tabsMedia[0]).addClass(this.activeContent).attr('aria-expanded', true)
            this.$tabsToggle.on('click touch', (e) => {
                this.openAccordion(e)
            })
        })
    }

    openAccordion(e) {
        this.mediaIndex = $(e.currentTarget).index()
        console.log("active content: ", $(this.$el).find('.' + this.activeContent))
        $(this.$el).find('.' + this.activeContent).removeClass(this.activeContent).attr('aria-expanded', false)
        $(this.tabsMedia[this.mediaIndex]).addClass(this.activeContent).attr('aria-expanded', true)
        $(e.currentTarget).addClass(this.activeTab)
        $(e.currentTarget).siblings('.' + this.activeTab).removeClass(this.activeTab).attr('aria-expanded', false)
        $(this.$el).find('.' + this.activeContent).attr('aria-expanded', true)
    }
}
